import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex align-center flex-wrap ga-2 mt-1 mb-2"
};
import { computed } from "vue";
import { usFaxDigits } from "@/composables/useRegisteredProviderAccount";
// A registered provider's confirmed fax (LAM-5508) is where a fax actually goes (LAM-5263), so a form value
// that differs from it is shown beside the account's — never silently overwritten.
export default /*@__PURE__*/ _defineComponent({
    __name: 'RegisteredContactDiscrepancy',
    props: {
        accountFax: {},
        formFax: {}
    },
    emits: ["apply"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const differs = computed(() => Boolean(props.accountFax) && usFaxDigits(props.formFax) !== usFaxDigits(props.accountFax));
        function applyAccountFax() {
            if (props.accountFax)
                emit("apply", props.accountFax);
        }
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            return (differs.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        color: "info",
                        label: "",
                        "prepend-icon": "mdi-account-check-outline"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" Provider's account fax: " + _toDisplayString(__props.accountFax), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "tonal",
                        color: "info",
                        "prepend-icon": "mdi-check",
                        onClick: applyAccountFax
                    }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" Use account fax ", -1)
                            ]))]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
